/* ITT MERGE STEP 1 — ONE RESIDENT IN THE STUDIO (PORT EDITION for the live theme, Nov 1, 2026)
   Integration contract with assets/itt-sigma-fit.js (which stays byte-identical
   and fully owns the studio panel: its catalog products, variant selects,
   NEA stylist text, price line, status line, macro/compare/save, and the
   VERIFIED add-to-bag via /cart/add.js):
   - This module NEVER writes to [data-products], [data-price],
     [data-stylist-answer] and never attaches handlers to [data-cart],
     [data-save], [data-compare], [data-rotate], [data-open-macro] or
     [data-ask]. Sigma's listeners are the only ones on those controls.
   - It renders the shared resident (the Dress-the-walk figure: identical
     460x760 mask-rig geometry) into the studio's .visual stage. The merge CSS
     hides sigma's own figure layers ([data-stage] WebGL canvas + .silhouette
     mannequin) while .itt-resident-on is present — the WebGL stage stays
     mounted but superseded; remove this module + its CSS and sigma's figures
     return untouched.
   - Piece selection for the resident lives in the ported section's own rail
     ([data-resident-products] inside [data-resident-rail]) — harness-proven
     featured four, driven through window.ITT_OUTFIT both ways.
   - The studio's presentation controls ([data-control] selects) keep working
     through sigma; this module only MIRRORS their change events into the
     shared state's .studio params and onto the resident figure. It never sets
     the selects' values, so sigma's internal state is never desynced.
   - The resident's ITT CODE chip + total live on the stage (sigma's price
     line is separate and remains sigma's). The studio gets its own code-apply
     box (same v2 codec as the embed). QA hook: window.__ITT_RESIDENT__. */
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';
  var SLOTKEY = { tops: 'top', bottoms: 'bottoms' };
  var VARKEY = { tops: 'topVar', bottoms: 'bottomsVar' };
  var PP_ORDER = ['leg-l', 'leg-r', 'waistband', 'sleeve-l', 'sleeve-r', 'torso', 'hood'];
  var FEATURED = [
    { slot: 'tops', id: 'rich-friends-hoodie' },
    { slot: 'tops', id: 'custom-picture-hoodie' },
    { slot: 'bottoms', id: 'itt-told-em-engraved-denim-third-edition' },
    { slot: 'bottoms', id: 'frog-skin-joggers' }
  ];
  var ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
  var params = { fit: 'tailored', finish: 'matte', topColor: null, pantsColor: null, sockColor: '#f1e8d8', shoeColor: '#171717' };

  function $(s, r) { return (r || document).querySelector(s); }
  function find(slot, id) {
    var list = (window.ITT_OUTFIT.items[slot] || []);
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }
  function curItem(slot) { return find(slot, window.ITT_OUTFIT.state[SLOTKEY[slot]]); }
  function itemVar(it, vid) {
    if (!it) return null;
    for (var i = 0; i < it.variants.length; i++) if (it.variants[i].vid === vid) return it.variants[i];
    return it.variants[0];
  }
  function curVar(slot) { var it = curItem(slot); return it ? itemVar(it, window.ITT_OUTFIT.state[VARKEY[slot]]) : null; }
  function hasParts(it) { return !!(it && it.pattern === 'ready' && it.parts && Object.keys(it.parts).length); }
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }
  function total() { var t = curVar('tops'), b = curVar('bottoms'); return (t ? t.p : 0) + (b ? b.p : 0); }
  function checksum(payload) { var h = 5; for (var i = 0; i < payload.length; i++) h = (h * 7 + ALPHABET.indexOf(payload.charAt(i)) + 3) % 31; return ALPHABET.charAt(h); }
  function currentCode() {
    var meta = window.ITT_OUTFIT.items.codeMeta;
    var t = curItem('tops'), b = curItem('bottoms');
    if (!meta || !t || !b) return '——————';
    var ti = t.vi + t.variants.indexOf(curVar('tops'));
    var pi = b.vi + b.variants.indexOf(curVar('bottoms'));
    var n = ti * meta.pantsVariantTotal + pi, m = n, s = '';
    for (var i = 0; i < 5; i++) { s = ALPHABET.charAt(m % 31) + s; m = Math.floor(m / 31); }
    if (m > 0) return '——————';
    return s + checksum(s);
  }
  function decode(raw) {
    if (!raw || !String(raw).trim()) return { error: 'Enter a code first.' };
    var s = String(raw).toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (s.indexOf('ITT') === 0) s = s.slice(3);
    if (s.length !== 6) return { error: 'An ITT Code is 6 characters — that was ' + s.length + '.' };
    for (var i = 0; i < s.length; i++)
      if (ALPHABET.indexOf(s.charAt(i)) < 0)
        return { error: '“' + s.charAt(i) + '” never appears in an ITT Code (we skip 0, 1, I, L and O so codes survive handwriting).' };
    if (checksum(s.slice(0, 5)) !== s.charAt(5)) return { error: 'That code does not check out — one character is off.' };
    var n = 0;
    for (var j = 0; j < 5; j++) n = n * 31 + ALPHABET.indexOf(s.charAt(j));
    var meta = window.ITT_OUTFIT.items.codeMeta;
    if (n >= meta.topVariantTotal * meta.pantsVariantTotal) return { error: 'That code does not match any outfit in the store.' };
    var ti = Math.floor(n / meta.pantsVariantTotal), pi = n % meta.pantsVariantTotal;
    var te = window.ITT_OUTFIT.items.fullIndex.tops[ti], pe = window.ITT_OUTFIT.items.fullIndex.bottoms[pi];
    var tItem = find('tops', te[0]), bItem = find('bottoms', pe[0]);
    if (!tItem || !bItem) return { outside: true, code: s };
    return { top: { item: tItem, variant: tItem.variants[te[1]] }, bottoms: { item: bItem, variant: pe ? bItem.variants[pe[1]] : bItem.variants[0] } };
  }

  /* ---------- persistence of presentation params on the shared state ---- */
  function persistParams() {
    try { if (window.ITT_OUTFIT) window.ITT_OUTFIT.state.studio = Object.assign({}, params); } catch (e) {}
    try {
      var rec = JSON.parse(localStorage.getItem('itt_outfit_v1') || 'null') || {};
      rec.studio = Object.assign({}, params);
      localStorage.setItem('itt_outfit_v1', JSON.stringify(rec));
    } catch (e) {}
  }
  function loadParams() {
    try {
      var rec = JSON.parse(localStorage.getItem('itt_outfit_v1') || 'null');
      if (rec && rec.studio) Object.assign(params, rec.studio);
    } catch (e) {}
  }

  /* ---------- the resident figure (embed-identical geometry) ------------ */
  var root, visual, svg, layersWrap = {}, clipEls = {}, boundaryEls = {}, tintEls = {}, fitG, legsG, sockEls = [], footEls = [], sheenEl;
  function svgEl(name, attrs) {
    var el = document.createElementNS(SVGNS, name);
    if (attrs) Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    return el;
  }
  function maskPaths(slot) { var it = curItem(slot); return (it && window.ITT_OUTFIT.items.masks[it.mask]) || []; }

  function buildFigure() {
    var NS = SVGNS;
    svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 460 760');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', 'The same resident from Dress the walk, wearing the current outfit in the fitting studio');
    var defs = svgEl('defs');
    clipEls.tops = svgEl('clipPath', { id: 'srClipTop' });
    clipEls.bottoms = svgEl('clipPath', { id: 'srClipBot' });
    var figClip = svgEl('clipPath', { id: 'srClipFig' });
    figClip.appendChild(svgEl('rect', { x: 0, y: 0, width: 460, height: 760, rx: 18 }));
    var grad = svgEl('linearGradient', { id: 'srSheen', x1: 0, y1: 0, x2: 1, y2: 0 });
    [['0', '0'], ['.5', '.5'], ['1', '0']].forEach(function (st) {
      grad.appendChild(svgEl('stop', { offset: st[0], 'stop-color': '#FFFFFF', 'stop-opacity': st[1] }));
    });
    defs.appendChild(clipEls.tops); defs.appendChild(clipEls.bottoms);
    defs.appendChild(figClip); defs.appendChild(grad);
    svg.appendChild(defs);

    var gAll = svgEl('g', { 'clip-path': 'url(#srClipFig)' });
    gAll.appendChild(svgEl('ellipse', { cx: 230, cy: 714, rx: 126, ry: 16, fill: 'rgba(30,27,22,.20)' }));

    fitG = svgEl('g');
    var limbs = svgEl('g', { stroke: '#4A4238', fill: 'none' });
    limbs.appendChild(svgEl('line', { x1: 152, y1: 168, x2: 110, y2: 392, 'stroke-width': 40, 'stroke-linecap': 'round' }));
    limbs.appendChild(svgEl('line', { x1: 308, y1: 168, x2: 350, y2: 392, 'stroke-width': 40, 'stroke-linecap': 'round' }));
    fitG.appendChild(limbs);
    fitG.appendChild(svgEl('path', { d: 'M148 148 L312 148 L330 402 L130 402 Z', fill: 'rgba(30,27,22,.05)', stroke: '#4A4238', 'stroke-width': 4 }));
    gAll.appendChild(fitG);

    legsG = svgEl('g', { stroke: '#4A4238', fill: 'none' });
    legsG.appendChild(svgEl('line', { x1: 196, y1: 404, x2: 186, y2: 700, 'stroke-width': 46, 'stroke-linecap': 'round' }));
    legsG.appendChild(svgEl('line', { x1: 264, y1: 404, x2: 274, y2: 700, 'stroke-width': 46, 'stroke-linecap': 'round' }));
    gAll.appendChild(legsG);

    layersWrap.bottoms = svgEl('g', { 'data-sr-wrap': 'bottoms' });
    layersWrap.tops = svgEl('g', { 'data-sr-wrap': 'tops' });
    gAll.appendChild(layersWrap.bottoms);
    /* tops layers live inside the fit group so silhouette params move the garment too */
    fitG.appendChild(layersWrap.tops);

    boundaryEls.bottoms = svgEl('path', { fill: 'none', stroke: '#0E9594', 'stroke-width': 3, 'stroke-linejoin': 'round', opacity: .92 });
    boundaryEls.tops = svgEl('path', { fill: 'none', stroke: '#FF5A3C', 'stroke-width': 3, 'stroke-linejoin': 'round', opacity: .92 });
    gAll.appendChild(boundaryEls.bottoms); gAll.appendChild(boundaryEls.tops);

    [168, 256].forEach(function (x) {
      var sock = svgEl('rect', { x: x, y: 672, width: 26, height: 26, rx: 7, fill: params.sockColor, stroke: '#4A4238', 'stroke-width': 2.5 });
      sockEls.push(sock); gAll.appendChild(sock);
    });
    [[180], [280]].forEach(function (cx) {
      var foot = svgEl('ellipse', { cx: cx[0], cy: 716, rx: 32, ry: 12, fill: params.shoeColor, stroke: '#4A4238', 'stroke-width': 2.5 });
      footEls.push(foot); gAll.appendChild(foot);
    });
    gAll.appendChild(svgEl('circle', { cx: 230, cy: 76, r: 47, fill: '#FFF8EF', stroke: '#4A4238', 'stroke-width': 4 }));
    sheenEl = svgEl('rect', { x: -60, y: -140, width: 210, height: 1040, fill: 'url(#srSheen)', transform: 'rotate(16)', style: 'mix-blend-mode:screen', 'class': 'res-sheen', opacity: 0 });
    gAll.appendChild(sheenEl);
    svg.appendChild(gAll);
    return svg;
  }

  function buildLayers(slot) {
    var it = curItem(slot);
    var g = svgEl('g', { 'data-sr-layers': '' });
    if (!it) return g;
    var paths = maskPaths(slot);
    var tone = svgEl('path', { d: paths.join(' '), fill: it.tone, 'data-sr-zone': slot });
    g.appendChild(tone);
    if (hasParts(it)) {
      PP_ORDER.forEach(function (pn) {
        var src = it.parts[pn]; if (!src) return;
        g.appendChild(svgEl('image', { href: src, x: 0, y: 0, width: 460, height: 760, 'data-sr-part': pn }));
      });
    } else {
      var cg = svgEl('g', { 'clip-path': 'url(#srClip' + (slot === 'tops' ? 'Top' : 'Bot') + ')' });
      var f = it.fit;
      cg.appendChild(svgEl('image', { href: it.thumb, x: f.x, y: f.y, width: f.w, height: f.h, preserveAspectRatio: 'xMidYMin slice', 'data-sr-photo': 'masked' }));
      g.appendChild(cg);
    }
    var tint = svgEl('path', { d: paths.join(' '), fill: '#000000', opacity: 0, 'data-sr-tint': slot, style: 'pointer-events:none' });
    tintEls[slot] = tint;
    g.appendChild(tint);
    return g;
  }

  function renderSlot(slot) {
    var paths = maskPaths(slot);
    clipEls[slot].innerHTML = paths.map(function (d) { return '<path d="' + d + '"/>'; }).join('');
    boundaryEls[slot].setAttribute('d', paths.join(' '));
    var wrap = layersWrap[slot];
    var old = wrap.querySelector('[data-sr-layers]');
    if (old) old.remove();
    wrap.appendChild(buildLayers(slot));
  }

  function applyParams() {
    var sx = params.fit === 'baggy' ? 1.1 : (params.fit === 'tapered' ? 0.94 : 1);
    fitG.setAttribute('transform', 'translate(' + (230 * (1 - sx)).toFixed(1) + ' 0) scale(' + sx + ' 1)');
    var lx = params.fit === 'baggy' ? 1.07 : 1;
    legsG.setAttribute('transform', 'translate(' + (230 * (1 - lx)).toFixed(1) + ' 0) scale(' + lx + ' 1)');
    sheenEl.setAttribute('opacity', params.finish === 'gloss' ? '.18' : (params.finish === 'shimmer' ? '.3' : '0'));
    if (tintEls.tops) { tintEls.tops.setAttribute('fill', params.topColor || '#000000'); tintEls.tops.setAttribute('opacity', params.topColor ? '.22' : '0'); }
    if (tintEls.bottoms) { tintEls.bottoms.setAttribute('fill', params.pantsColor || '#000000'); tintEls.bottoms.setAttribute('opacity', params.pantsColor ? '.22' : '0'); }
    sockEls.forEach(function (s) { s.setAttribute('fill', params.sockColor || '#f1e8d8'); });
    footEls.forEach(function (f) { f.setAttribute('fill', params.shoeColor || '#171717'); });
  }

  /* ---------- chip / rail sync (sigma's price + stylist stay sigma's) --- */
  var chipCode, chipTotal, statusEl, railMsgEl, msgEl;
  function setStatus(t) { if (statusEl) statusEl.textContent = t; }
  function syncPanel() {
    if (chipCode) chipCode.textContent = currentCode();
    if (chipTotal) chipTotal.textContent = money(total());
    root.querySelectorAll('[data-sr-product]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(window.ITT_OUTFIT.state[SLOTKEY[btn.dataset.srSlot]] === btn.dataset.srProduct));
    });
  }
  function renderAll() { renderSlot('tops'); renderSlot('bottoms'); applyParams(); syncPanel(); }

  /* ---------- the resident rail (its own container in the ported section;
     sigma's [data-products] is never touched) --------------------------- */
  function buildRail() {
    var wrap = root.querySelector('[data-resident-rail]');
    var host = root.querySelector('[data-resident-products]');
    if (!wrap || !host) return;
    railMsgEl = root.querySelector('[data-resident-msg]');
    var built = 0;
    FEATURED.forEach(function (f) {
      var it = find(f.slot, f.id);
      if (!it) return;
      var entry = document.createElement('div');
      entry.className = 'itt-product-entry';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'itt-sigma-product';
      btn.dataset.srProduct = it.id;
      btn.dataset.srSlot = f.slot;
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = '<img src="' + it.thumb + '" alt="" loading="lazy" width="200" height="250">' +
        '<span>' + it.name + '</span><small>' + money(it.price) + ' · ' + (f.slot === 'tops' ? 'Top' : 'Bottoms') + '</small>';
      btn.addEventListener('click', function () {
        window.ITT_OUTFIT.setOutfit(f.slot, it.id, it.vid);
        if (railMsgEl) railMsgEl.textContent = it.name + ' is on the resident — Dress the walk shows the same look.';
      });
      entry.appendChild(btn);
      host.appendChild(entry);
      built++;
    });
    if (built > 0) wrap.hidden = false;
  }

  /* ---------- presentation controls: MIRROR ONLY. Sigma's own change
     listener validates + applies to its state/viewer; ours additionally
     records the choice on the shared state and repaints the resident.
     Values are never written back into the selects. --------------------- */
  function wireControls() {
    root.querySelectorAll('[data-control]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var key = sel.dataset.control;
        if (!(key in params)) return;
        params[key] = sel.value;
        persistParams(); applyParams();
      });
    });
  }

  function wireApply(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var dec = decode(form.querySelector('input').value);
      if (dec.error) { msgEl.textContent = dec.error; msgEl.classList.add('err'); return; }
      if (dec.outside) {
        msgEl.textContent = 'That outfit lives in the full creator. Take code ' + dec.code + ' — it rebuilds there exactly.';
        msgEl.classList.remove('err'); return;
      }
      window.ITT_OUTFIT.setOutfit('tops', dec.top.item.id, dec.top.variant.vid);
      window.ITT_OUTFIT.setOutfit('bottoms', dec.bottoms.item.id, dec.bottoms.variant.vid);
      msgEl.textContent = 'Outfit rebuilt — ' + dec.top.item.name + ' × ' + dec.bottoms.item.name + '.';
      msgEl.classList.remove('err');
    });
  }

  function init() {
    root = document.querySelector('[data-itt-sigma]');
    if (!root || !window.ITT_OUTFIT) return;
    loadParams();
    root.classList.add('itt-resident-on');
    visual = root.querySelector('.visual');
    if (!visual) return;
    var holder = document.createElement('div');
    holder.className = 'itt-resident';
    holder.appendChild(buildFigure());
    var chip = document.createElement('div');
    chip.className = 'itt-resident-chip';
    chip.innerHTML = 'ITT CODE <b data-sr-code>——————</b><span class="sep">·</span><span data-sr-total></span>';
    holder.appendChild(chip);
    var stamp = document.createElement('div');
    stamp.className = 'itt-resident-stamp';
    stamp.textContent = 'Iťtoldem';
    holder.appendChild(stamp);
    var form = document.createElement('form');
    form.className = 'itt-resident-apply';
    form.innerHTML = '<input type="text" maxlength="12" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="TYPE THE CODE" aria-label="Type an ITT Code to rebuild the outfit here">' +
      '<button type="submit">APPLY →</button><p class="msg" data-sr-msg aria-live="polite"></p>';
    holder.appendChild(form);
    visual.appendChild(holder);
    chipCode = chip.querySelector('[data-sr-code]');
    chipTotal = chip.querySelector('[data-sr-total]');
    msgEl = form.querySelector('[data-sr-msg]');
    wireApply(form);
    statusEl = root.querySelector('[data-status]');
    buildRail();
    wireControls();
    renderAll();
    persistParams();
    /* Sigma mounts via a deferred module script and writes its own ready
       line into [data-status] after this classic script runs; re-assert the
       merge line once it has settled, and after the first outfit change. */
    var mergeLine = 'One resident, synced with Dress the walk — dress him anywhere, he is dressed everywhere.';
    setStatus(mergeLine);
    setTimeout(function () { setStatus(mergeLine); }, 1600);
    var asserted = false;
    document.addEventListener('itt:outfit-changed', function () {
      renderAll();
      persistParams();
      if (!asserted) { asserted = true; setStatus(mergeLine); }
    });
    window.__ITT_RESIDENT__ = function () {
      return {
        code: currentCode(), total: total(),
        topTone: (curItem('tops') || {}).tone || null,
        bottomsTone: (curItem('bottoms') || {}).tone || null,
        topZoneFill: (function () { var z = svg.querySelector('[data-sr-zone="tops"]'); return z ? z.getAttribute('fill') : null; })(),
        bottomsZoneFill: (function () { var z = svg.querySelector('[data-sr-zone="bottoms"]'); return z ? z.getAttribute('fill') : null; })(),
        params: Object.assign({}, params),
        sigmaRenderer: root.getAttribute('data-renderer') || null,
        stageHidden: (function () { var s = root.querySelector('[data-stage]'); return s ? window.getComputedStyle(s).display : null; })()
      };
    };
  }

  var tries = 0;
  (function wait() {
    if (window.ITT_OUTFIT && document.querySelector('[data-itt-sigma]')) { init(); return; }
    if (++tries < 60) setTimeout(wait, 100);
  })();
})();
